'use client';

import { DataTestIdEnum } from '@medprev-web-app/datatestid';

import { LaboratoryExamsFlowKeys } from '@/app/(main)/(pages)/(institucional)/(index)/laboratorios/_components/laboratory-exams-flow/laboratory-exams-flow.types';
import { ExamsCoverage } from '@/app/(main)/_components/search-modal/_variants/exams-coverage.component';
import { PartnerExamsCoverage } from '@/app/(main)/_components/search-modal/search-modal.types';
import { useProgressiveModal } from '@/components/ui/progressive-modal/progressive-modal.hook';

interface LaboratoryCoverageStepProps {
  coverage?: PartnerExamsCoverage;
}

export function LaboratoryCoverageStep({ coverage }: LaboratoryCoverageStepProps) {
  const { handleJump, onClose } = useProgressiveModal<LaboratoryExamsFlowKeys>();

  if (!coverage) {
    return null;
  }

  return (
    <ExamsCoverage
      coverage={coverage}
      dataTestId={DataTestIdEnum.BRANCH_LABORATORY_COVERAGE_MODAL}
      onAddMoreExams={() => handleJump({ key: LaboratoryExamsFlowKeys.EXAMS })}
      onSeeSchedules={() => handleJump({ key: LaboratoryExamsFlowKeys.SCHEDULES })}
      onClose={onClose}
    />
  );
}
